<ng-container *ngIf="setupComplete">
    <div *ngIf="!pasteMode || options.useQuestionBank" class="acs-selector-toolbar">
        <div class="acs-selector-search form-group has-prefix quick-search dw-grid-quick-search-action__search">
            <input type="text" class="form-control" aria-label="Search ACS codes" placeholder="Search..."
                [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (ngModelChange)="searchChanged()">
            <span class="fa fa-search form-control-prefix" aria-hidden="true"></span>
        </div>
        <button type="button" class="btn acs-selector-button" (click)="selectAllCodeRows()" [disabled]="pasteBusy">Select All</button>
        <button type="button" class="btn acs-selector-button" (click)="clearAllCodeSelections()" [disabled]="pasteBusy">Clear All</button>
        <button *ngIf="options.useQuestionBank == false" type="button" class="btn acs-selector-button"
            (click)="showPasteCodes()" aria-controls="acs-paste-panel" [attr.aria-expanded]="pasteMode">
            <i class="fa fa-paste" aria-hidden="true"></i> Paste Codes
        </button>
    </div>
    <div *ngIf="options.useQuestionBank == false && pasteMode" id="acs-paste-panel" class="acs-selector-paste">
        <div class="acs-selector-toolbar">
            <textarea id="paste-acs-codes" class="form-control acs-selector-paste-input" rows="1"
                [(ngModel)]="pastedCodesText" [ngModelOptions]="{standalone: true}"
                aria-label="Paste ACS codes from your knowledge test result"
                placeholder="Paste ACS Code (e.g. PA.I.A.K1 PA.II.B.K2)" [disabled]="pasteBusy"></textarea>
            <button type="button" class="btn acs-selector-button" (click)="applyPastedCodes()"
                [disabled]="pasteBusy || !pastedCodesText.trim() || !options.acsTestId">{{pasteBusy ? 'Matching...' : 'Apply'}}</button>
            <button type="button" class="btn acs-selector-button" (click)="backToSearch()">
                <i class="fa fa-search" aria-hidden="true"></i> Search
            </button>
        </div>
        <div *ngIf="pasteSummary" class="acs-selector-feedback" role="status" aria-live="polite">{{pasteSummary}}</div>
    </div>
    <div dwRow *ngIf="options?.allowQuestionSelect">
        <div dwCol="6">
            <label class="label">Select Questions <i class="fa fa-info-circle"
                    title="Show questions from the Question bank for each ACS Code"></i></label>
                <dw-yesno [(ngModel)]="options.useQuestionBank" (ngModelChange)="onOptionChange()"></dw-yesno>
        </div>
        <div dwCol="6">
            <label class="label">Limit to Missed Codes <i class="fa fa-info-circle"
                    title="Limit the codes to only codes added to the Missed ACS Codes"></i></label>
                <dw-yesno [(ngModel)]="showOnlyMissedAcsCodes" (ngModelChange)="onOptionChange()"></dw-yesno>
        </div>
    </div>
    <dw-meta-data-grid #acsCodesGrid *ngIf="options.useQuestionBank == false" [item]="aosCodesItem" configKeyPart="select-codes"
        [filters]="codesGridFilters" allowConfig="true" [preferences]="codesGridPreferences"
        (gridEvent)="onCodeGridEvent($event)" [gridCallbacks]="gridCallbacks"></dw-meta-data-grid>
    <dw-meta-data-grid #acsCodesGrid *ngIf="options.useQuestionBank == true" [item]="aosCodesItem" configKeyPart="select-questions"
        [filters]="questionGridFilters" allowConfig="true" [preferences]="questionsGridPreferences"
        (gridEvent)="onQuestionGridEvent($event)" [gridCallbacks]="gridCallbacks"></dw-meta-data-grid>
</ng-container>

<!-- Filters: {{codesGridFilters | json}} -->
